<template>
  <section>
    <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs6>
        <v-autocomplete
          :items="tramites"
          v-model="caso.id_tramite"
          label="Trámite"
          item-text="text"
          item-value="value"
          noDataText="No hay resultados"
          :rules="$validate(['required'])"
          required
          ></v-autocomplete>
      </v-flex>
      <v-flex xs6>
        <v-autocomplete
          :items="tiposCaso"
          v-model="caso.tipo"
          label="Tipo de caso"
          noDataText="No hay resultados"
          :rules="$validate(['required'])"
          required
          ></v-autocomplete>
      </v-flex>
      <v-flex xs12>
        <v-textarea
          name="descripcion"
          label="Descripción"
          id="descripcion"
          v-model="caso.descripcion"
          maxlength="200"
          :rules="$validate(['required'])"
          counter
          required
        ></v-textarea>
      </v-flex>
      <v-flex xs12 v-if="persona.id == 0">
        <v-alert
          outline
          color="primary"
          :value="true" >
          <div class="text-xs-justify">
            <p><v-icon>warning</v-icon> Para cambiar de Tipo de Caso SIMPLE a otro debe VERIFICAR los datos de la persona.</p>
          </div>
        </v-alert>
      </v-flex>
    </v-layout>
    </v-container>
  </section>
</template>

<script>
import validate from '@/common/mixins/validate';

export default {
  mixins: [ validate ],
  props: ['id', 'canalUsuario', 'cubiculo', 'persona'],
  watch: {
    'caso.tipo' (val) {
      this.prepararCaso();
    },
    'caso.id_tramite' (val) {
      this.prepararCaso();
    },
    'caso.descripcion' (val) {
      this.prepararCaso();
    }
  },
  created () {
    this.user = this.$storage.getUser();
  },
  mounted () {
    this.$nextTick(() => {
      this.listarTramites();
      this.recuperarCaso();
    });
  },
  data () {
    return {
      valid: false,
      caso: { id: 0 },
      loading: false,
      tramites: [],
      tiposCaso: ['SIMPLE']
    };
  },
  beforeCreate () {

  },
  computed: {
    resultado () {
      return this.caso;
    }
  },
  methods: {
    asociarCaso () {
      this.$emit('recuperarCaso', this.caso);
    },
    listarTramites () {
      this.$service.get(`system/tramites`, {})
      .then(response => {
        if (response) {
          let items = response.rows;
          let tramites = [];
          items.map(est => {
            tramites.push({ value: est.id, text: est.nombre_tramite });
          });
          this.tramites = tramites;
        }
      });
    },
    recuperarCaso () {
      if (this.id > 0) {
        this.loading = true;
        this.$loading.show('recuperando caso');
        this.$service.get(`system/operadores/caso/${this.id}`, {})
        .then(response => {
          if (response) {
            this.caso = response;
            this.prepararCaso();
            this.$emit('recuperarCaso', this.caso);
            this.loading = false;
          }
        });
      }
    },
    prepararCaso () {
      if (this.persona) {
        if (this.persona.id > 0) {
          this.caso.id_persona = this.persona.id;
          this.tiposCaso = ['SIMPLE', 'COMPLEJO'];
        }
      }
      if (this.cubiculo) {
        this.caso.id_punto_atencion = this.cubiculo;
      }
      if (this.user) {
        this.caso.operador_principal = this.user.usuario;
      }
      if (this.caso.operadores && this.caso.operadores.length > 0) {
        if (this.caso.operadores.indexOf(this.user.usuario) === -1) {
          this.caso.operadores.push(this.user.usuario);
        }
      } else {
        this.caso.operadores = [this.user.usuario];
      }
      if (this.canalUsuario) {
        this.caso.canal_principal = this.canalUsuario;
      }
      if (this.caso.canales && this.caso.canales.length > 0) {
        if (this.caso.canales.indexOf(this.canalUsuario.id) === -1) {
          this.caso.canales.push(this.canalUsuario.id);
        }
      } else if (this.canalUsuario.id) {
        this.caso.canales = [this.canalUsuario.id];
      }
      this.$emit('recuperarCaso', this.caso);
    }
  },
  components: {}
};
</script>



// WEBPACK FOOTER //
// src/components/admin/operadores/CasoModal.vue